<template>
  <v-card>
    <v-card-title>
      <div style="cursor: pointer" @click="goToAdditionalServicesTable">Doplňkové služby</div>
      <div style="margin-right: 15px; margin-left: 15px">--></div>
      {{ data.name }}
    </v-card-title>
    <v-form @submit.prevent="updateAdditionalServiceData">
      <v-card-text>
        <v-row>
          <v-col cols="6" sm="4">
            <v-text-field disabled hide-details="auto" label="ID" v-model="data._id" outlined filled dense />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" sm="4">
            <v-text-field hide-details="auto" label="Název" v-model="data.name" outlined filled dense />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" sm="4">
            <v-select
                hide-details="auto"
                v-model="data.serviceTypeId"
                :items="translatedServiceTypes"
                item-text="translatedName"
                item-value="_id"
                label="Typ služby"
                outlined filled dense />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" sm="4">
            <v-text-field hide-details="auto" type="number" label="Trvání v minutách" v-model.number="data.duration" outlined filled dense />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" sm="4">
            <v-text-field hide-details="auto" type="number" min="0" label="Fixní cena" v-model.number="data.fixedPrice" outlined filled dense />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6" sm="4">
            <v-text-field hide-details="auto" type="number" min="0" max="100" label="Podíl poskytovatele (%)" v-model.number="data.providerPercentualShare" outlined filled dense />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small color="primary" class="mx-1" type="submit">Uložit</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import UserBlockDialog from '@/components/app/users/UserBlockDialog'
import UserCardDetails from '@/components/app/users/details/UserCardDetails'
import PartnerCardDetails from "@/components/app/partners/details/PartnerCardDetails";
import _ from "lodash-es"

export default {
  name: "PartnerCard",
  components: {
    UserCardDetails,
    UserBlockDialog,
    PartnerCardDetails
  },
  props: {
    id: {
      required: false,
      default: () => null
    },
    creating: {
      type: Boolean
    }
  },
  data() {
    return {
      data: {},
      copyData: {},
      saveModel: {},
      serviceTypes: []
    }
  },
  mounted() {
    this.getData()
    this.getServiceTypes()
  },
  methods: {
    getData() {
      this.axios.get('/v1/additional-services/' + this.id)
          .then(({data}) => {
            this.data = data
            this.copyData = {...data}
          }).catch(() => this.$router.go(-1))
    },
    getObjectDiff(obj1, obj2) {
      return Object.keys(obj1).reduce((result, key) => {
        if (!obj2.hasOwnProperty(key)) {
          result.push(key);
        } else if (_.isEqual(obj1[key], obj2[key])) {
          const resultKeyIndex = result.indexOf(key);
          result.splice(resultKeyIndex, 1);
        }
        return result;
      }, Object.keys(obj2));
    },
    updateAdditionalServiceData() {
      let diffKeys = this.getObjectDiff(this.data, this.copyData)
      let diffData = {}
      diffKeys.forEach(dataKey=>{
        diffData[dataKey] = this.data[dataKey]
      })
      this.axios.patch('/v1/additional-services/' + this.id, diffData)
          .then(()=>{
            this.$store.commit('addAlert', {
              type: 'success',
              message: "Úspěšně"
            })
          })
          .catch((el)=>{
            if (el.response && el.response.data && el.response.data.errors){
              el.response.data.errors.forEach((error)=>{
                this.$store.commit('addAlert', {
                  type: 'error',
                  message: error.message
                })
              })
            }else{
              this.$store.commit('addAlert', {
                type: 'error',
                message: "Chyba"
              })
            }
          })
          .finally()
    },
    goToAdditionalServicesTable() {
      this.$router.push("/app/additional-services")
    },
    getServiceTypes() {
      this.axios.get('v1/service-types', { params: { limit: 50 } })
        .then(({data}) => {
          this.serviceTypes = data.data || []
        })
    },
    translateServiceType(serviceName) {
      const translations = {
        'cleaning': 'Úklid',
        'general_cleaning': 'Generální úklid',
        'carpet_beating': 'Tepování',
      }
      return translations[serviceName] || serviceName
    }
  },
  computed: {
    translatedServiceTypes() {
      return this.serviceTypes.map(st => ({
        ...st,
        translatedName: this.translateServiceType(st.serviceName)
      }))
    }
  },
  watch: {
    data: {
      deep: true,
      handler: function (value) {
      }
    }
  }
}
</script>

<style scoped>

</style>
